import { Card, Typography } from '@mui/material';

export default function AboutUs() {
    return (
        <Card className="card">
            <Typography variant="h5" gutterBottom>关于我们</Typography>
            <Typography>
                我们是一支充满激情和创造力的团队，致力于通过技术创新改变世界...
            </Typography>
        </Card>
    );
}
